export const iconFontAwesomeScienceFire = (
	<i className="fa-solid fa-fire"></i>
);
